<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-documents">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-folder-tree"></i>
                                <span>Documente</span>
                            </mat-card-title>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div class="p-3" *ngFor="let docTypeKey of getDocumentTypeKeys()">
                        <button type="button" class="btn btn-light upload-btn">
                            <span class="upload__text">
                                <i class="fa-solid fa-layer-group"></i> &nbsp;
                                {{ cerere.documente[docTypeKey].name }}
                            </span>
                        </button>
                        <div class="p-2">
                            <mat-divider></mat-divider>
                        </div>
                        <div class="p-3" *ngFor="let docKey of getDocumentKeys(docTypeKey)">
                            <mat-card-subtitle>{{ cerere.documente[docTypeKey].documente[docKey].name }}
                            </mat-card-subtitle>
                            <div class="p-2">
                                <mat-divider></mat-divider>
                            </div>
                            <div class="docs d-flex flex-row justify-content-start align-items-center flex-wrap">
                                <button type="button" class="btn btn-light upload-btn m-2"
                                    *ngFor="let file of cerere.documente[docTypeKey].documente[docKey].files"
                                    (click)="downloadDocument(file)">
                                    <span class="upload__text">
                                        <img src="assets/icons/icon-download-blue.svg" alt="Descarcă" />
                                        &nbsp;{{ file.name }}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>